import axiosClient from "@/utils/axios-client";
import {
  OrderHistoryConfirmedAmendOrderRequest,
  OrderHistoryConfirmedUpdateStatusRequest,
  OrderHistoryConfirmedRequest,
  OrderHistoryConfirmedResponse,
  OrderHistoryConfirmedApproveConfirmResponse,
} from "@/features/my-order/features/order-history/features/final-copy/types";

const url = {
  getConfirmedList: (params: OrderHistoryConfirmedRequest) =>
    `/${params.companyType}/${params.companyId}/order-sheet-sets/${params.orderSheetSetId}/confirmed`,
  postAmendOrder: (buyer_id: number) =>
    `/buyers/${buyer_id}/requests/amend-order`,
  updateStatus: (company_type: string, company_id: number) =>
    `/${company_type}/${company_id}/order-sheet-sets/bulk-update-status`,
};

export const OrderHistoryConfirmedApi = {
  getConfirmedList: async (params: OrderHistoryConfirmedRequest) => {
    const { data } = await axiosClient.get<OrderHistoryConfirmedResponse>(
      url.getConfirmedList(params)
    );
    return data;
  },
  postAmendOrder: async (
    buyer_id: number,
    params: OrderHistoryConfirmedAmendOrderRequest
  ) => await axiosClient.post(url.postAmendOrder(buyer_id), params),
  updateStatus: async (
    companyType: string,
    companyId: number,
    params: OrderHistoryConfirmedUpdateStatusRequest
  ) => {
    const { data } =
      await axiosClient.put<OrderHistoryConfirmedApproveConfirmResponse>(
        url.updateStatus(companyType, companyId),
        params
      );
    return data;
  },
};
